import { BackendMessagesFR } from './backendMessagesFR';
import buildingFR from './messages/building.json';
import dashboardCustomizeFR from './messages/dashboard/customize.json';
import dashboardCustomTabsFR from './messages/dashboard/customTabs.json';
import dashboardFR from './messages/dashboard/dashboard.json';
import dashboardWidgetLibraryFR from './messages/dashboard/widgetLibrary.json';
import dashboardWidgetsFR from './messages/dashboard/widgets.json';
import invoiceLifecycleFR from './messages/invoiceLifecycle.json';
import leaseInventoryFR from './messages/leaseInventory.json';
import propertySiteFR from './messages/propertySite.json';
import tagFR from './messages/tag.json';
import technicFR from './messages/technic.json';
import ticketsFR from './messages/tickets.json';

export const MessagesFR = {
  ...BackendMessagesFR,
  building: buildingFR,
  dashboard: {
    ...dashboardFR,
    widgets: dashboardWidgetsFR,
    widgetLibrary: dashboardWidgetLibraryFR,
    customize: dashboardCustomizeFR,
    customTabs: dashboardCustomTabsFR,
  },
  invoiceLifecycle: invoiceLifecycleFR,
  leaseInventory: leaseInventoryFR,
  propertySite: propertySiteFR,
  tag: tagFR,
  technic: technicFR,
  tickets: ticketsFR,
};
